module.exports = __webpack_public_path__ + "img/primary_7x1_z16.51faf4a8.svg";